import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { createFragmentContainer, graphql } from 'react-relay';
import { getFilterValues } from '../sbSharedRefineMenuHelpers';
import { updateUriRef } from '../../../actions/filterActions';
import { AbsoluteAnchor } from '../../../global/AbsoluteAnchor/AbsoluteAnchor';

// styles
import style from './SbSharedRefineMenuColorSelect.scss';

export const SbSharedRefineMenuColorSelectComponent = props => {
    const { filter, onChange, itemSearch, filterName } = props;
    const { appliedFilters } = itemSearch;
    const appliedFilterValues = getFilterValues(appliedFilters, filterName);
    const selected = appliedFilterValues.map(color => color.urlLabel);

    return (
        <div className={style.container}>
            {filter.values.map((color, idx) => {
                const isSelected = selected.includes(color.urlLabel);

                return (
                    <div
                        key={`${color.displayName}-${idx}`}
                        className={style.colorSelect}
                        data-color={color.displayName}
                        onClick={() => onChange(color, isSelected)}
                        data-tn={`color-${color.displayName}`.toLowerCase()}
                    >
                        <AbsoluteAnchor
                            linkReference={color.linkReference}
                            linkable={color.linkable}
                            title={color.displayName}
                            onClick={e => e.preventDefault()}
                        >
                            <span
                                className={classnames(style.swatch, {
                                    [style.selected]: isSelected,
                                })}
                                style={{ backgroundColor: color.hexCode }}
                            />
                        </AbsoluteAnchor>
                    </div>
                );
            })}
        </div>
    );
};

SbSharedRefineMenuColorSelectComponent.defaultProps = {
    onChange: () => {},
};

SbSharedRefineMenuColorSelectComponent.propTypes = {
    filter: PropTypes.object.isRequired,
    itemSearch: PropTypes.object.isRequired,
    filterName: PropTypes.string.isRequired,
    onChange: PropTypes.func,
};

function mapDispatchToProps(dispatch, { filterName }) {
    return {
        onChange(filterValue, isDeselected) {
            dispatch(updateUriRef({ filterName, filterValue, isDeselected }));
        },
    };
}

export const SbSharedRefineMenuColorSelect = createFragmentContainer(
    connect(
        null,
        mapDispatchToProps
    )(SbSharedRefineMenuColorSelectComponent),
    {
        itemSearch: graphql`
            fragment SbSharedRefineMenuColorSelect_itemSearch on ItemSearchQueryConnection {
                appliedFilters {
                    name
                    values {
                        urlLabel
                    }
                }
            }
        `,
    }
);
